import { sendUserTemplateEmail } from "@/lib/email/send.functions";

interface SendTransactionalEmailParams {
  templateName: string;
  recipientEmail: string;
  idempotencyKey?: string;
  templateData?: Record<string, any>;
}

export async function sendTransactionalEmail(p: SendTransactionalEmailParams) {
  return sendUserTemplateEmail({
    data: {
      templateName: p.templateName as "welcome-signup" | "practice-abandonment",
      recipientEmail: p.recipientEmail,
      idempotencyKey: p.idempotencyKey,
      templateData: p.templateData,
    },
  });
}
